// src/context/MerchantContext.js
import React, { createContext, useContext, useState, useEffect } from 'react';
import { onAuthChange, getMerchantShop, saveShopFcmToken } from '../services/firebase';

const MerchantContext = createContext();
export const useMerchant = () => useContext(MerchantContext);

export const MerchantProvider = ({ children }) => {
  const [merchant, setMerchant] = useState(null);
  const [shop, setShop] = useState(null);
  const [authLoading, setAuthLoading] = useState(true);

  useEffect(() => {
    const unsub = onAuthChange(async (user) => {
      setMerchant(user);
      if (user) {
        const shopData = await getMerchantShop(user.uid);
        setShop(shopData);
        if (shopData?.id) saveShopFcmToken(shopData.id);
      } else {
        setShop(null);
      }
      setAuthLoading(false);
    });
    return unsub;
  }, []);

  return (
    <MerchantContext.Provider value={{ merchant, shop, shopId: shop?.id ?? null, setShop, authLoading }}>
      {children}
    </MerchantContext.Provider>
  );
};
